// import api from "@/api";
import CpdScoreText from "@/components/CpdScoreText/CpdScoreText.vue";
import { authUserIsAdmin, authUserIsCurator } from "@/utils/auth";
import { startsWith } from "lodash-es";

export default {
  name: "Navigation",
  components: { CpdScoreText },
  computed: {
    /**
     * Convert navigation_items_order config item into an array of item names.
     */
    navigationItemsOrder() {
      return this.$store.state.config.navigation_items_order.split(",");
    },
    /**
     * Determine whether the user is an administrator.
     */
    isAdmin() {
      return authUserIsAdmin();
    },
    /**
     * Determine whether the user is a curator.
     */
    isCurator() {
      return authUserIsCurator();
    },
    /**
     * Determine whether or not the current route is a PDL page.
     */
    pdlActive() {
      return ["userProfessionalDevelopmentLog", "userGroupLeaderLog"].includes(this.$route.name);
    },
    /**
     * Determine whether or not the current route is a forum page.
     */
    forumActive() {
      return [
        "forumCategories",
        "forumCategory",
        "forumPost",
        "forumPostAdd",
        "forumCategoryAdd",
        "forumCategoryEdit",
      ].includes(this.$route.name);
    },
    /**
     * Determine whether or not the current route is a curation page.
     */
    curationActive() {
      return ["curationCollections", "curationContent", "curationTags", "newCollection", "collection"].includes(
        this.$route.name
      );
    },
    /**
     * Determine the URL to use in the logout link.
     */
    logoutUrl() {
      if (this.$store.state.config.sso_enabled && this.$store.state.user.sso_enabled) {
        return startsWith(this.$store.state.config.sso_sign_out_url, "/")
          ? this.$store.state.config.sso_sign_out_url
          : `/${this.$store.state.config.sso_sign_out_url}`;
      }
      return "/logout";
    },

    /**
     * Work out whether responsive mode is on, or if the hamburger menu should be shown always.
     */
    isResponsive() {
      return !!this.$store.state.config.navigation_responsive_on;
    },
  },
};
